module.exports = require("./pa-Arab-PK.js");